import React,{ Component } from 'react';
import { Modal, Button} from 'rsuite';
class MissionBillboard extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="modal-container">
                <Modal show={this.props.show} onHide={this.close}>
                    <Modal.Header>
                        <Modal.Title>{this.props.data.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>                        
                        {"截止时间：" + this.props.data.deadline}
                        <br />                        
                        {this.props.data.mContext}
                    </Modal.Body>
                    <Modal.Footer>
                        {"发布时间：" + this.props.data.uploadDate}
                        <br />
                        {"发布人：" + this.props.data.uploaderName}
                        <br />
                        <Button onClick={this.props.close} appearance="primary">
                            确认
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default MissionBillboard;